import { createContext } from 'react';
import { useSafeContext } from '@mews/framework';
import { Product, ProductCategory, Service, ServiceType } from '@mews-commander/data-access';

interface ServicesProductsContextValue {
    productsByServiceType: Record<
        ServiceType.Bookable | ServiceType.Additional,
        { service: Service; products: Product[] }[]
    >;
    productCategories: ProductCategory[];
}

const ServicesProductsContext = createContext<ServicesProductsContextValue | null>(null);

export const ServicesProductsContextProvider = ServicesProductsContext.Provider;

ServicesProductsContext.displayName = 'ServicesProductsContext';

export const useServicesProductsContext = () => useSafeContext(ServicesProductsContext);
